import { Tooltip } from "antd";
import "./sport-tooltip.css";

const SportTooltip = ({ children, title, placement = "top", ...rest }) => {
  return (
    <Tooltip
      title={title}
      placement={placement}
      classNames={{root: "sport-tooltip"}}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

export default SportTooltip;
